export enum restrictedPagesEnum {
  MyAccount = 'REGISTRATION_SUCCESS',
  MyAccountPersonalDetails = 'MY_ACCOUNT',
  MyAccountAddressBook = 'ADDRESS_BOOK',
  MyAccountPurchaseHistory = 'PERSONAL_DETAILS',
  RegistrationSuccess = 'PURCHASE_HISTORY',
}

export enum restrictedPagesWhenAuthEnum {
  Login = 'LOGIN',
  Registration = 'REGISTRATION',
}
